/**
 * Labstep
 *
 * @module core/Link
 * @desc Wrapper around react-router-dom RouterLink
 */

import cx from 'classnames';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import styles from './styles.module.scss';
import type { LinkProps } from './types';

export const Link: React.FC<LinkProps> = (props) => {
  const {
    children,
    to,
    params,
    unstyled,
    underline,
    className,
    query,
    disabled,
    dataCy,
    ...rest
  } = props;

  const cxArgs: cx.ArgumentArray = [
    { [styles.underline]: underline },
    { [styles.unstyled]: unstyled },
    { [styles.disabled]: disabled },
  ];
  if (className) {
    cxArgs.push({ [className]: className });
  }
  const classes = cx(...cxArgs);

  return (
    <RouterLink
      data-cy={dataCy}
      className={classes}
      to={disabled ? null : navigation.get(to, params, false, query)}
      {...rest}
    >
      {children || navigation.get(to, params, true, query)}
    </RouterLink>
  );
};

Link.defaultProps = {
  unstyled: false,
};
